import { SVGProps } from '@components/Icon/types';

export const Autoscale = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.3, 2.3)">
      <path
        d="M0 1.7C0 0.761116 0.761116 0 1.7 0H5.7C6.0866 0 6.4 0.313401 6.4 0.7C6.4 1.0866 6.0866 1.4 5.7 1.4H1.7C1.53431 1.4 1.4 1.53431 1.4 1.7V5.7C1.4 6.0866 1.0866 6.4 0.7 6.4C0.313401 6.4 0 6.0866 0 5.7V1.7Z"
        fill={fill}
      />
      <path
        d="M13 0.7C13 0.313401 13.3134 0 13.7 0H17.7C18.6389 0 19.4 0.761116 19.4 1.7V5.7C19.4 6.0866 19.0866 6.4 18.7 6.4C18.3134 6.4 18 6.0866 18 5.7V1.7C18 1.53431 17.8657 1.4 17.7 1.4H13.7C13.3134 1.4 13 1.0866 13 0.7Z"
        fill={fill}
      />
      <path
        d="M0.7 13C1.0866 13 1.4 13.3134 1.4 13.7V17.7C1.4 17.8657 1.53431 18 1.7 18H5.7C6.0866 18 6.4 18.3134 6.4 18.7C6.4 19.0866 6.0866 19.4 5.7 19.4H1.7C0.761116 19.4 0 18.6389 0 17.7V13.7C0 13.3134 0.313401 13 0.7 13Z"
        fill={fill}
      />
      <path
        d="M18.7 13C19.0866 13 19.4 13.3134 19.4 13.7V17.7C19.4 18.6389 18.6389 19.4 17.7 19.4H13.7C13.3134 19.4 13 19.0866 13 18.7C13 18.3134 13.3134 18 13.7 18H17.7C17.8657 18 18 17.8657 18 17.7V13.7C18 13.3134 18.3134 13 18.7 13Z"
        fill={fill}
      />
      <path
        d="M11.1345 4.89318C11.2305 4.95852 11.3465 4.99671 11.4715 4.99671L13.3817 4.99671L9.70371 8.6747L6.02572 4.99671H7.93595C8.26732 4.99671 8.53595 4.72808 8.53595 4.39671C8.53595 4.06533 8.26732 3.7967 7.93595 3.7967L4.40042 3.7967C4.06905 3.7967 3.80042 4.06533 3.80042 4.39671L3.80042 7.93224C3.80042 8.26361 4.06905 8.53224 4.40042 8.53224C4.73179 8.53224 5.00042 8.26361 5.00042 7.93224L5.00042 6.02201L8.67841 9.7L5.00041 13.378L5.00041 11.4678C5.00041 11.1364 4.73179 10.8678 4.40041 10.8678C4.06904 10.8678 3.80041 11.1364 3.80041 11.4678L3.80041 15.0033C3.80041 15.3347 4.06904 15.6033 4.40041 15.6033L7.93595 15.6033C8.26732 15.6033 8.53595 15.3347 8.53595 15.0033C8.53595 14.6719 8.26732 14.4033 7.93595 14.4033L6.02571 14.4033L9.70371 10.7253L13.3817 14.4033L11.4715 14.4033C11.1401 14.4033 10.8715 14.6719 10.8715 15.0033C10.8715 15.3347 11.1401 15.6033 11.4715 15.6033H15.007C15.3384 15.6033 15.607 15.3347 15.607 15.0033V11.4678C15.607 11.1364 15.3384 10.8678 15.007 10.8678C14.6756 10.8678 14.407 11.1364 14.407 11.4678L14.407 13.378L10.729 9.7L14.407 6.022V7.93225C14.407 8.26362 14.6756 8.53225 15.007 8.53225C15.3384 8.53225 15.607 8.26362 15.607 7.93225L15.607 4.39671C15.607 4.06534 15.3384 3.79671 15.007 3.79671L11.4715 3.79671C11.1401 3.79671 10.8715 4.06534 10.8715 4.39671C10.8715 4.60314 10.9757 4.78522 11.1345 4.89318Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'autoscale';
